import { initButtonDescriptors } from "src/pages/OfferPage/DocuSectionButtons/docuSectionButtonDefs";

export const getAllDependentKeysToTurnOff = (buttonId: string): string[] => {
    const descriptors = initButtonDescriptors();
    const dependents: string[] = [];

    const visit = (parentId: string) => {
        descriptors.forEach((desc) => {
            if (desc.dependencies?.includes(parentId) && desc.propertyKey) {
                dependents.push(desc.propertyKey);
                visit(desc.buttonId);
            }
        });
    };

    visit(buttonId);
    return dependents;
};

export const getAllRequiredParentKeysToTurnOn = (buttonId: string): string[] => {
    const descriptors = initButtonDescriptors();
    const parents: string[] = [];

    const visit = (childId: string) => {
        const child = descriptors.find((desc) => desc.buttonId === childId);
        if (child?.dependencies) {
            child.dependencies.forEach((depId) => {
                const parent = descriptors.find((desc) => desc.buttonId === depId);
                if (parent?.propertyKey) {
                    parents.push(parent.propertyKey);
                    visit(parent.buttonId);
                }
            });
        }
    };

    visit(buttonId);
    return parents;
};

export type ProjectQuoteChange = { propertyKey: string; value: number | string };

export const computeQuotePropertyChanges = (
    propertyKey: string,
    value: number | string
): ProjectQuoteChange[] => {
    const descriptors = initButtonDescriptors();
    const currentButton = descriptors.find((desc) => desc.propertyKey === propertyKey);

    if (!currentButton) return [];

    const changes: ProjectQuoteChange[] = [{ propertyKey, value }];

    if (value === 1) {
        const toEnable = getAllRequiredParentKeysToTurnOn(currentButton.buttonId);
        toEnable.forEach((key) => changes.push({ propertyKey: key, value: 1 }));
    } else if (value === 0) {
        const toDisable = getAllDependentKeysToTurnOff(currentButton.buttonId);
        toDisable.forEach((key) => changes.push({ propertyKey: key, value: 0 }));
    }

    return changes;
};